import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface UserDocumentType {
  name: string;
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly fallbackUserDocumentTypes: UserDocumentType[] = [
    { name: 'Cédula de Ciudadanía', code: 'CC' },
    { name: 'Cédula de extranjería', code: 'CE' },
    { name: 'Pasaporte', code: 'PA' },
    { name: 'NIT', code: 'NIT' },
    { name: 'Permiso especial', code: 'PEP' },
    { name: 'Permiso de protección temporal', code: 'PPT' },
  ];

  constructor() { }


  clean(): void {
    window.localStorage.clear();
  }

  saveSelectedMall(mall: any): void {
    window.localStorage.removeItem('mall');
    window.localStorage.setItem('mall', JSON.stringify(mall));
  }

  getSelectedMall(): any {
    const mall = window.localStorage.getItem('mall');
    if (mall) {
      return JSON.parse(mall);
    }
    return null;
  }

  getUserDocumentTypes(): UserDocumentType[] {
    const documentTypes = this.getSelectedMall()?.user_document_types;

    if (!Array.isArray(documentTypes) || documentTypes.length === 0) {
      return this.fallbackUserDocumentTypes;
    }

    const validDocumentTypes = documentTypes.filter(
      (documentType: any) => documentType?.name && documentType?.code,
    );

    return validDocumentTypes.length > 0
      ? validDocumentTypes
      : this.fallbackUserDocumentTypes;
  }

  getDefaultUserDocumentTypeCode(): string {
    const documentTypes = this.getUserDocumentTypes();
    const ccDocumentType = documentTypes.find(
      (documentType) => documentType.code === 'CC',
    );

    return ccDocumentType?.code || documentTypes[0]?.code || 'CC';
  }

  saveSelectedChannel(channel: any): void {
    window.sessionStorage.removeItem('channel');
    window.sessionStorage.setItem('channel', JSON.stringify(channel));
  }

  getSelectedChannel(): any {
    const channel = window.sessionStorage.getItem('channel');
    if (channel) {
      return JSON.parse(channel);
    }
    return null;
  }


  getSelectedChannelId(): any {
    const channel = window.sessionStorage.getItem('selectedChannelId');
    if (channel) {
      return JSON.parse(channel);
    }
    return null;
  }

  saveMaxLimitPerBill(maxLimit: any): void {
    window.localStorage.removeItem('maxLimit');
    window.localStorage.setItem('maxLimit', JSON.stringify(maxLimit));
  }

  saveMaxLimitPerPhotoBill(maxLimit: any): void {
    window.localStorage.removeItem('maxPhotoLimit');
    if (maxLimit === undefined) return;

    window.localStorage.setItem('maxPhotoLimit', JSON.stringify(maxLimit));
  }

  getMaxLimitPerBill(): any {
    const maxLimit = window.localStorage.getItem('maxLimit');
    if (maxLimit) {
      return JSON.parse(maxLimit);
    }
    return null;
  }

  getMaxLimitPerPhotoBill(): any {
    const maxLimit = window.localStorage.getItem('maxPhotoLimit');
    if (maxLimit) {
      return JSON.parse(maxLimit);
    }
    return null;
  }


  saveUser(user: any): void {
    window.localStorage.removeItem('user');
    window.localStorage.setItem('user', JSON.stringify(user));
  }

  savePermission(user: any): void {
    window.localStorage.removeItem('permission');
    window.localStorage.setItem('permission', JSON.stringify(user));
  }

  saveToken(token: string): void {
    window.localStorage.removeItem('token');
    window.localStorage.setItem('token', token);
  }

  saveRefreshToken(token: string): void {
    window.localStorage.removeItem('refresh_token');
    window.localStorage.setItem('refresh_token', token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem('refresh_token');
  }

  getAuthToken(): string | null {
    return localStorage.getItem('token');
  }

  getUser(): any {
    const user = window.localStorage.getItem('user');
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  getPermission(): any {
    const permission = window.localStorage.getItem('permission');
    if (permission) {
      return JSON.parse(permission);
    }
    return {};
  }

  isLoggedIn(): boolean {
    const token = window.localStorage.getItem('token');
    // console.log(token);
    if (token) {
      return true;
    }
    return false;
  }

  getAuthHeaders(token?: string) {

    let sessionToken = token ?  token : window.localStorage.getItem('token')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionToken
      })
    }

    return httpOptions
  }

  getSessionAuthHeaders() {
    let sessionToken = window.sessionStorage.getItem('lite_token');
    console.debug('session token: ', sessionToken)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionToken
      })
    };

    return httpOptions;
  }

  getSessionToken() {
    return window.sessionStorage.getItem('lite_token');
  }

  getTokenFromStorage() {
    return window.localStorage.getItem('token');
  }

  getSimpleAuthHeaders() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    })
    return headers
  }


  saveChannelCity(city: any) {
    localStorage.setItem('channelCity', JSON.stringify(city));
  }

  getChannelCity() {
    const city = localStorage.getItem('channelCity');
    return city ? JSON.parse(city) : null;
  }
}
